<template>
  <div class="navigation-buttons">
    <button
      v-show="!isQotD && showPrevious"
      :class="{ 'disabled': disablePrevious }"
      :disabled="disablePrevious"
      class="flex-row navigation"
      data-test="prev-button"
      @click="$emit('previous-flashcard')"
    >
      <icon
        name="arrow-left-uui"
        variant="697586"
      ></icon>
      <span class="no-mobile">
        Prev
      </span>
    </button>
    <button
      v-show="!isQotD && showNext"
      :class="{ 'disabled': disableNext }"
      :disabled="disableNext"
      class="flex-row navigation"
      data-test="next-button"
      @click="$emit('next-flashcard')"
    >
      <span class="no-mobile">
        Next
      </span>
      <icon
        name="arrow-right-uui"
        variant="697586"
      ></icon>
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: { Icon },
  props: {
    isQotD: {
      type: Boolean,
      default: false,
    },
    showPrevious: {
      type: Boolean,
      default: false,
    },
    disablePrevious: {
      type: Boolean,
      default: false,
    },
    showNext: {
      type: Boolean,
      default: false,
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['previous-flashcard', 'next-flashcard'],
};
</script>

<style lang="scss" scoped>
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .25rem;
}

.navigation-buttons {
  display: flex;
  gap: 1rem; /* Assuming some gap between buttons if they are side-by-side, though original didn't explicitly wrapper them, they were siblings in a flex container */
}

.navigation {
  background-color: transparent;
  padding: 0;
  color: #697586;
  border: none; /* Ensure no border for button */
  cursor: pointer;
}

button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.no-mobile {
  display: none;
}

@include breakpoint(tablet) {
  .no-mobile {
    display: inline;
  }
}

@include breakpoint(desktop) {
  .no-mobile {
    display: inline;
  }
}
</style>
